import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { cloud, purple, semibold, silver, text, graphite } from '@rover/react-bootstrap'
import { DonutChart } from '@rover/react-icons'

import TableMenuBarIcon from './TableMenuBarIcon'
import ColumnDisplayContainer from './ColumnDisplayContainer'
import DeviceExportModal from './DeviceExportModal'

const tableMenuBarStyle = {
    flex: '0 0 auto',
    height: 70,
    width: '100%',
    backgroundColor: cloud,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 43,
}

const tableMenuBarLeft = {
    flex: '1 1',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
}

const tableMenuDonutIconStyle = {
    flex: '0 0',
    marginRight: 11,
}

const tableMenuNumberRatio = {
    marginRight: 12,
}

class TableMenuBarAlpha extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchVal: '',
            showColumnsMenu: false,
            pageClickLocation: {
                x: 0,
                y: 0,
            },
            isShowingDeviceExportModal: false,
        }
        this.handleSearch = this.handleSearch.bind(this)
        this.triggerColumnsMenu = this.triggerColumnsMenu.bind(this)
        this.showChecked = this.showChecked.bind(this)
        this.numberWithCommas = this.numberWithCommas.bind(this)
        this.closeDeviceExportModal = this.closeDeviceExportModal.bind(this)
    }

    handleSearch(e) {
        this.setState({ searchVal: e.target.value })
    }

    triggerColumnsMenu() {
        const { top, left } = document.getElementById('columnsIcon').getBoundingClientRect()

        this.setState({
            showColumnsMenu: !this.state.showColumnsMenu,
            pageClickLocation: {
                x: left,
                y: top + 40,
            },
        })
    }

    showChecked(item) {
        const { selectedColumns } = this.props
        const key = `${item.attribute}_${item.selector}`
        return key in selectedColumns
    }

    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    closeDeviceExportModal() {
        this.setState({ isShowingDeviceExportModal: false })
    }

    renderDeviceExportMenuIcon() {
        return (
            <div style={{ height: '100%' }} onClick={_ => this.setState({ isShowingDeviceExportModal: true })}>
                <TableMenuBarIcon
                    val="download"
                    showToolTip={true}
                    style={{
                        borderTopLeftRadius: 2,
                        borderBottomLeftRadius: 2,
                    }}
                />
            </div>
        )
    }

    render() {
        const { showColumnsMenu, pageClickLocation, isShowingDeviceExportModal } = this.state
        const { platformFeatures, updateChecked, allColumns, segmentSize, skeleton, totalSize, selectedColumns } =
            this.props

        if (skeleton) {
            return <div style={tableMenuBarStyle} />
        }

        return (
            <div style={tableMenuBarStyle}>
                <ColumnDisplayContainer
                    showColumnsMenu={showColumnsMenu}
                    updateChecked={updateChecked}
                    showChecked={this.showChecked}
                    triggerColumnsMenu={this.triggerColumnsMenu}
                    pageClickLocation={pageClickLocation}
                    allColumns={allColumns}
                />

                <div style={tableMenuBarLeft}>
                    <div style={tableMenuDonutIconStyle}>
                        <DonutChart
                            amountFilled={(segmentSize / totalSize) * 80}
                            amountEmpty={((totalSize - segmentSize) / totalSize) * 80}
                            primaryColor={silver}
                            accentColor={purple}
                        />
                    </div>

                    <div style={tableMenuNumberRatio}>
                        <div
                            style={{
                                ...semibold,
                                ...text,
                                fontSize: 20,
                                lineHeight: 1.2,
                                color: graphite,
                            }}
                        >
                            {this.numberWithCommas(segmentSize)}
                        </div>
                        <div style={{ ...text, fontSize: 13, color: silver }}>
                            of {this.numberWithCommas(totalSize)} total devices
                        </div>
                    </div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ height: '100%' }} onClick={e => this.props.refreshData()}>
                            <TableMenuBarIcon
                                val="refresh"
                                showToolTip={true}
                                style={{
                                    borderTopLeftRadius: 2,
                                    borderBottomLeftRadius: 2,
                                }}
                            />
                        </div>
                        <div
                            style={{
                                height: '100%',
                                width: 1,
                                backgroundColor: graphite,
                            }}
                        />
                        {platformFeatures.includes('data') && totalSize !== 0 && this.renderDeviceExportMenuIcon()}
                        {platformFeatures.includes('data') && (
                            <div
                                style={{
                                    height: '100%',
                                    width: 1,
                                    backgroundColor: graphite,
                                }}
                            />
                        )}
                        <div style={{ height: '100%' }} onClick={e => this.triggerColumnsMenu(e)} id="columnsIcon">
                            <TableMenuBarIcon
                                val="columns"
                                showToolTip={!showColumnsMenu}
                                style={{
                                    borderTopRightRadius: 2,
                                    borderBottomRightRadius: 2,
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isShowingDeviceExportModal && (
                    <DeviceExportModal
                        isOpen={isShowingDeviceExportModal}
                        onRequestClose={this.closeDeviceExportModal}
                        selectedColumns={selectedColumns}
                        totalSize={totalSize}
                    />
                )}
            </div>
        )
    }
}

TableMenuBarAlpha.propTypes = {
    platformFeatures: PropTypes.arrayOf(PropTypes.string).isRequired,
    updateChecked: PropTypes.func.isRequired,
    allColumns: PropTypes.arrayOf(
        PropTypes.shape({
            attribute: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            __typename: PropTypes.string.isRequired,
            selector: PropTypes.string.isRequired,
            group: PropTypes.string.isRequired,
        })
    ).isRequired,
    predicates: PropTypes.string.isRequired,
    segmentSize: PropTypes.number.isRequired,
    totalSize: PropTypes.number.isRequired,
    selectedColumns: PropTypes.object.isRequired,
    skeleton: PropTypes.bool,
}

TableMenuBarAlpha.defaultProps = {
    platformFeatures: [],
    updateChecked: () => null,
    allColumns: [],
    predicates: '[]',
    segmentSize: 0,
    totalSize: 0,
    selectedColumns: {},
    skeleton: false,
}

export default TableMenuBarAlpha
